const Resume = () => {
    return (
        <div className="resume">
            <h1> Resume </h1>
            <div className="resume-tab">
                <h2 className="resume-title">Resume in English</h2>
                <a
                    href="/resume/resume.pdf"
                    download="Martin Mircea Ioan - Resume"
                    target="_blank"
                    rel="noreferrer"
                >
                    <h3>Download my Resume in English</h3>
                </a>
            </div>

            <div className="resume-tab">
                <h2 className="resume-title">Resume in German</h2>
                <a
                    href="/resume/lebenslauf.pdf"
                    download="Martin Mircea Ioan - Lebenslauf"
                    target="_blank"
                    rel="noreferrer"
                >
                    <h3>Lebenslauf auf Deutsch herunterladen</h3>
                </a>
            </div>

        </div>
    );
};

export default Resume;